import System from "src/helper/system";
import HCLDX from "./hcldx";

class Auth {
    static SAVE_USER_PREFRENCE_URL = System.getBaseUrl() + `/api/user/saveUserPreference`;
    static REGISTER_USER_URL = System.getBaseUrl() + `/api/user/adduser`;
    static SEARCH_CROSS_REFERENCE_PARTS_URL = System.getDesignHubUrl() + `/api/designhub/searchCrossReferenceParts`;

    static getCrossReferenceToolRouteURL() {
        return HCLDX.baseURL() + '/solutions/product-and-solutions-design/design-hub/crossreferencetool';
    }
}

export default Auth;